"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

import { pushPageviewDataLayer } from "@/utils/analytics";

const AnalyticsPageView = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const key = `${pathname}?${searchParams?.toString() || ""}`;

  useEffect(() => {
    pushPageviewDataLayer(key);
  }, [key]);

  return null;
};

export default AnalyticsPageView;
